var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAttachMoney = function SvgAttachMoney(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M528.649 465.067c-96.853-25.173-128.002-51.2-128.002-91.733 0-46.507 43.095-78.933 115.202-78.933 75.947 0 104.107 36.267 106.667 89.6h94.293c-2.987-73.387-47.787-140.8-136.96-162.56v-93.44h-128v92.16c-82.775 17.92-149.335 71.68-149.335 154.027 0 98.56 81.493 147.627 200.535 176.213 106.667 25.6 128 63.147 128 102.827 0 29.44-20.907 76.373-115.2 76.373-87.893 0-122.455-39.253-127.148-89.6h-93.867c5.12 93.44 75.093 145.92 157.015 163.413v92.587h128v-91.733c83.2-15.787 149.333-64 149.333-151.467 0-121.173-103.68-162.56-200.533-187.733z"
  })));
};
export default SvgAttachMoney;